import { createStorageAtomFactory } from '@exodus/atoms';
import ms from 'ms';
const createAutoLockTimerAtom = ({ storage }) => {
    const atomFactory = createStorageAtomFactory({ storage });
    return atomFactory({
        key: 'autoLockTimer',
        defaultValue: ms('60m'),
    });
};
export default createAutoLockTimerAtom;
